import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaypointService } from '../../../services/paypoint.service';
import { filter, switchMap, take } from 'rxjs/operators';
import { LayoutUtility } from 'src/app/shared/utils';
@Component({
  selector: 'kt-bridgepay-view-routing-rules',
  templateUrl: './view-routing-rules.component.html',
  styleUrls: ['./view-routing-rules.component.scss'],
})
export class ViewRoutingRulesComponent implements OnInit {
  @Input() routingRules: any[] = [];
  @Output() addRule = new EventEmitter<void>();
  organization: any;
  officeId: any;
  isSubmitting: boolean;

  constructor(
    private route: ActivatedRoute,
    private layoutUtility: LayoutUtility,
    private paypointService: PaypointService,
    private cd: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.route.params
      .pipe(
        take(1),
        filter((params) => params['companyUUID'] && params['officeUUID']),
        switchMap((params) => {
          this.organization = params['companyUUID'];
          this.officeId = params['officeUUID'];
          return this.paypointService.getRoutingRule(this.organization, this.officeId);
        }),
      )
      .subscribe((response) => {
        this.routingRules = response.data;
        this.cd.detectChanges();
      });
  }

  onDeleteRule(rule: any): void {
    this.layoutUtility
      .openConfirmationDialog({
        themeColor: 'danger',
        iconPath: 'assets/icons/Error.svg',
        content: `
              <div class="ks-font-weight-medium">
                <div class="ks-body-lg ks-mb-2">Delete routing rule</div>
                <div class="ks-body-md ks-text-neutral">You will not be able to recover it</div>
              </div>
            `,
        cancelLabel: 'No, cancel',
        confirmLabel: 'Yes, delete routing rule',
      })
      .pipe(take(1))
      .subscribe((confirmed) => {
        if (confirmed) {
          this.paypointService
            .deleteRoutingRule(this.organization, rule['routing-rule_code'])
            .subscribe(() => {
              this.addRule.emit();
            });
        }
      });
  }
}
